<template>
    <div class="about content">
        <div class="bread">
            <bread :data="[{path: '/about', title: '关于我们'}]"></bread>
        </div>

        <card class="types">
            <span slot="title">
                关于我们
            </span>
            <!--
            <tab-btn
                :data="types"
                v-model="type"
            ></tab-btn>-->
        </card>

        <card class="main-con">
            <div 
                class="rich-text" 
                v-if="type === 'about'" 
                v-html="richPreHandler(detail.infocontent)"
            ></div>

        </card>
    </div>
</template>

<script>
import Card from '@components/sys/card';
import List from '@components/sys/list';
import Bread from '@components/sys/bread';
import TabBtn from '@components/sys/tab-btn';

export default {
    components: {
        Card,
        List,
        Bread,
        TabBtn,
    },
    data() {
        return {
            tableData: [],
            pgData: {
                categoryid: '105',
                sortorder: 'desc',
                sortname: 'infodate',
                featurecode:this.$siteConfig.planName,
                pagesize:10,
                pageindex:'1'
            },
            type: 'about',
            types: [
                {
                    label: '关于我们',
                    value: 'about'
                },
            ],
            detail: {},
        }
    },
    methods: {
        queryAbout() {
            var that = this;
            that.$get(`${this.$store.state.api.webUrl}/index/information/getwebinfopg.json`,this.pgData, data => {
                if(window.location.href.split(":")[0]=='https'){
                    that.$get(`${this.$store.state.api.webUrl}/index/information/getwebinfodetail.json`, {
                        infoid: '-'+data.rows[0].infoid,
                    }, data => {
                        that.detail = data;
                    })
                }else{
                    that.$get(`${this.$store.state.api.webUrl}/index/information/getwebinfodetail.json`, {
                        infoid: data.rows[0].infoid,
                    }, data => {
                        that.detail = data;
                    })
                }
            });

            // this.$get(`${this.$store.state.api.webUrl}/index/information/getwebinfodetail.json`, {
            //     infoid: 9
            // }, data => {
            //     this.detail = data;
            // });
        },
        richPreHandler(html) {
            if (!html) return '';

            var res = html;

            res = res.replace(/&nbsp;/g, '');

            return res;
        },
        queryDownload() {
            this.$get(`${this.$store.state.api.webUrl}/index/information/getmoretooldownload.json`, {
                infoid: 9
            }, data => {
                var list = data;

                list.forEach(function(item,index){
                    if(item.by5){
                        if(item.by5.indexOf(',') !=-1){
                            var url = item.by5.split(',');
                            list[index].urlList = url;
                        }
                    }
                });

                this.tableData = list;
            });
        },
    },
    mounted() {
        this.queryAbout();
        this.queryDownload();
    },
}
</script>

<style lang="scss" scoped>
@import '@css/var.scss';

.about{
    margin-bottom: 26px;

    .types{
        margin-bottom: 12px;

        .type-sel{
            overflow: hidden;

            .item{
                float: left;
                font-size: 16px;
                line-height: 1em;
                padding: 8px 10px;
                border-radius: 18px;
                border: 1px solid #d6d6d6;
                cursor: pointer;

                & + .item{
                    margin-left: 1em;
                }

                &.active{
                    color: white;
                    background: $primaryColor;
                    border-color: $primaryColor;
                }
            }
        }
    }

    .main-con{
        min-height: 400px;
    }

    .page{
        margin-top: 1em;
    }
}
</style>
